import { useCroWeb173Experiment } from "@/src/experiments/cro-web-173/useCroWeb173Experiment";
import ElemseeTestimonial from "@/src/features/onboarding/components/ElemseeTestimonial";
import WelcomeFeatureList from "@/src/features/onboarding/components/WelcomeFeatureList";
import clsx from "clsx";

const WelcomeStep = ({ stepData }: any) => {
  const heading = stepData?.heading;
  const description = stepData?.description;

  // Get experiment configuration
  const { showFeatureList, showTestimonial } = useCroWeb173Experiment();

  return (
    <div
      className={clsx(
        "WelcomeStep",
        "flex h-full w-full flex-col items-start justify-start lg:flex-row"
      )}
    >
      <div className="flex flex-col bg-white text-black">
        <div className="flex max-w-md flex-1 flex-col justify-center space-y-6 lg:space-y-12">
          <h1 className="font-spatial text-3xl font-medium md:pt-5 md:text-5xl">
            {heading}
          </h1>

          {showFeatureList && <WelcomeFeatureList description={description} />}

          {showTestimonial && (
            <div className="hidden md:block">
              <ElemseeTestimonial />
            </div>
          )}

          {/* Show testimonial on mobile for all social proof variants */}
          {showTestimonial && (
            <div className="block md:hidden">
              <ElemseeTestimonial />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep;
